<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <h3 class="headline mt-0">{{ $t('Shippop') }}</h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <v-btn fab outline small color="primary" v-if="!isEdit" @click="editShippop">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <div>
      บริการเชื่อมต่อการขนส่งสินค้า เพื่อช่วยทางเพจในการส่งสินค้าได้สะดวกมากยิ่งขึ้น
      สามารถเปรียบเทียบราคาค่าจัดส่งสินค้า ชำระเงินออนไลน์ได้ง่ายๆ ผ่านบัตรเครดิตและบัตรเดบิต
      สามารถออกหมายเลขพัสดุ และพิมพ์ใบปะหน้าพัสดุได้จากระบบทันที
      รวมถึงการติดตามสถานะพัสดุได้ผ่านระบบ
      ทำให้ท่านสามารถควบคุมค่าใช้จ่ายและวางแผนค่าขนส่งล่วงหน้าได้อย่างง่ายดาย
    </div>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1"> สมัคร Shippop </v-stepper-step>
        <v-stepper-content step="1">
          <div>เชื่อมต่อกับบริการ Shippop ได้ฟรี พร้อมการส่งสินค้าที่สะดวกยิ่งขึ้น</div>
          <v-btn
            depressed
            color="primary"
            :href="'https://www1.shippop.com/embed/register/zwiz/'"
            target="_blank"
            @click="step = 2"
            >สมัคร Shippop</v-btn
          >
          <div>
            <a
              href="https://blog.zwiz.ai/%e0%b9%81%e0%b8%88%e0%b9%89%e0%b8%87%e0%b9%80%e0%b8%a5%e0%b8%82%e0%b8%9e%e0%b8%b1%e0%b8%aa%e0%b8%94%e0%b8%b8%e0%b8%96%e0%b8%b6%e0%b8%87%e0%b8%a5%e0%b8%b9%e0%b8%81%e0%b8%84%e0%b9%89%e0%b8%b2%e0%b9%84/"
              target="_blank"
              >ดูวิธีการใช้งานอย่างละเอียด</a
            >
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" :complete="step > 2"> เชื่อมต่อ Zwiz กับ Shippop </v-stepper-step>
        <v-stepper-content step="2">
          <div class="mb-2" v-if="showCancel">
            <div>
              {{ $t('เปิด/ปิด การใช้งาน Shippop') }}
            </div>
            <div>
              <label
                class="toggle-switch small"
                style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
              >
                <input
                  :disabled="loading"
                  type="checkbox"
                  :checked="shippop_status"
                  @change="toggleStatus()"
                />
                <span class="toggle-slider lever round"></span>
              </label>
            </div>
          </div>

          <template v-if="!showCancel"
            >หลังจากได้รับการยืนยันจาก Shippop แล้ว สามารถนำ Token
            มาใส่เพื่อทำการเชื่อมต่อที่นี่</template
          >
          <div class="caption">Shippop Token</div>
          <div class="form-control" :class="{ 'has-error': errors.has('shippop_jsonvalue_token') }">
            <template v-if="isEdit">
              <input
                type="text"
                v-model="shippop_jsonvalue.token"
                v-validate="'required'"
                name="shippop_jsonvalue_token"
                data-vv-as="Shippop Token"
              />
              <span class="text-error" v-if="errors.has('shippop_jsonvalue_token')">{{
                errors.first('shippop_jsonvalue_token')
              }}</span>
            </template>
            <div class="primary--text" v-else>
              {{ shippop_jsonvalue.token ? shippop_jsonvalue.token : '-' }}
            </div>
          </div>

          <div class="caption mt-2">Shippop Email</div>
          <div class="form-control" :class="{ 'has-error': errors.has('shippop_jsonvalue_email') }">
            <template v-if="isEdit">
              <input
                type="text"
                v-model="shippop_jsonvalue.email"
                v-validate="'required|email'"
                name="shippop_jsonvalue_email"
                data-vv-as="Shippop Email"
              />
              <span class="text-error" v-if="errors.has('shippop_jsonvalue_email')">{{
                errors.first('shippop_jsonvalue_email')
              }}</span>
            </template>
            <div class="primary--text" v-else>
              {{ shippop_jsonvalue.email ? shippop_jsonvalue.email : '-' }}
            </div>
          </div>

          <div class="text-xs-center" v-if="isEdit">
            <v-btn color="grey" outline @click="onCancel" v-if="showCancel">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn color="primary" depressed @click="onSave">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  data() {
    return {
      step: 1,
      shippop_jsonvalue: {
        email: null,
        token: null
      },
      shippop_status: false,
      isEdit: false,
      loading: true,
      showCancel: true
    }
  },
  async mounted() {
    this.loading = true
    var response = await this.getshippop()
    if (response.data && response.data.length > 0) {
      try {
        this.shippop_status = response.data[0].shippop_status
        if (response.data[0].shippop_jsonvalue)
          this.shippop_jsonvalue = JSON.parse(response.data[0].shippop_jsonvalue)
      } catch (error) {}
    }
    if (
      (this.shippop_jsonvalue && this.shippop_jsonvalue.token == null) ||
      !this.shippop_jsonvalue
    ) {
      this.editShippop()
      this.showCancel = false
    } else {
      this.step = 2
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    editShippop() {
      this.isEdit = true
      this.cached_shippop_jsonvalue = JSON.stringify(this.shippop_jsonvalue)
      this.cached_shippop_status = this.shippop_status
    },
    onCancel() {
      this.isEdit = false
      this.shippop_jsonvalue = JSON.parse(this.cached_shippop_jsonvalue)
      this.shippop_status = this.cached_shippop_status
    },
    getshippop() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getshippop({ pageid: vm.selectedBot.pageid }, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async toggleStatus() {
      var vm = this
      const status = !vm.shippop_status
      try {
        await vm.saveShippop({
          params: {
            pageid: vm.selectedBot.pageid
          },
          body: {
            shippop_status: status,
            shippop_jsonvalue: JSON.stringify(vm.shippop_jsonvalue)
          }
        })
        await this.$store.dispatch('updateBotDetail')
        vm.shippop_status = status
      } catch (error) {
        console.log(error)
      }
    },
    async saveShippop(data) {
      return new Promise((resolve, reject) => {
        api.saveshippop(data, (error, response) => {
          if (error) {
            reject(error)
          }

          resolve(response)
        })
      })
    },
    async onSave() {
      try {
        if (
          this.shippop_jsonvalue.token != null &&
          this.shippop_jsonvalue.email != null &&
          this.shippop_status == null
        )
          this.shippop_status = true
        var result = await this.$validator.validateAll()
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        await this.saveShippop({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            shippop_status: this.shippop_status,
            shippop_jsonvalue: JSON.stringify(this.shippop_jsonvalue)
          }
        })
        await this.$store.dispatch('updateBotDetail')

        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })

        this.cached_shippop_jsonvalue = JSON.stringify(this.shippop_jsonvalue)
        this.cached_shippop_status = this.shippop_status

        this.isEdit = false
        this.showCancel = true
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippopManage.vue